import './notification-download-file.scss';
import React from 'react';
import CustomIcon, { IconType } from '../../../shared/custom-icon/custom-icon';
import { LogNotificationDto, NotificationDownloadStatus } from '../../../../dtos/notification.dto';
import { Tooltip } from 'antd';
import { useStores } from '../../../store';
import { formatDescriptionLine } from '../../../../utils/string-normalization';
import { observer } from 'mobx-react-lite';
import usePromiseFeedback from '../../../shared/promise-feedback/usePromiseFeedback';

interface DownloadFileElementProps {
    notification: LogNotificationDto;
}
const NotificationDownloadFile: React.FC<DownloadFileElementProps> = observer(({ notification }) => {

    const { notificationStore } = useStores();
    const [promiseFeedbackFactory, promiseContextHolder] = usePromiseFeedback();

    const formattedDescription = notification.description?.split('\n').map((line) => (
        <span key={line} className="line">
         {formatDescriptionLine(line)}
        </span>
    ));

    const downloadFile = () => {
        if(notification.fileName) {
            promiseFeedbackFactory({
                promise: notificationStore.downloadLogFile(notification.id, notification.fileName),
                notifObj: { show: false },
                errorCallback: () => notificationStore.markNotificationAsDownloadFailure(notification.id)
            });
        }
    };

    return <div className="download-log">
        <div className="file-name">
            <CustomIcon type={IconType.ZIP}/>
            <div>{notification.fileName}</div>
            <Tooltip title={formattedDescription} overlayClassName="file-description-tooltip" placement={'bottom'}>
                <CustomIcon type={IconType.INFO}/>
            </Tooltip>
        </div>
        <div className="file-size">
            <span>{notification.fileSize}</span>
            {notificationStore.notificationDownloadStatus[notification.id] === NotificationDownloadStatus.DOWNLOADING ?
                <div className="downloading-icon">
                    <div className="loader" />
                </div> :
                <button type="button" className="download-icon" aria-label="Download file" onClick={downloadFile}>
                    <CustomIcon type={IconType.DOWNLOAD} />
                </button> }
        </div>
        {promiseContextHolder}
    </div>;
});

export default NotificationDownloadFile;
